import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { FirebaseApp, getApps, initializeApp } from "firebase/app";
import { Auth, GoogleAuthProvider, getAuth, signInWithPopup } from "firebase/auth";

// Second, separately-named Firebase app instance for Google sign-in, pointed at web's
// Firebase project (environment.webFirebaseConfig) — deliberately distinct from the
// default app in custom-firebase.module.ts, which is wired to a different Firebase
// project (fishyhub-uat / fishyhub-prod) for the unrelated auction realtime-DB feature.
const AUTH_APP_NAME = "authApp";

@Injectable({
  providedIn: "root",
})
export class AuthFirebaseService {
  private readonly app: FirebaseApp;
  private readonly auth: Auth;

  constructor() {
    const existing = getApps().find((app) => app.name === AUTH_APP_NAME);
    this.app = existing ?? initializeApp(environment.webFirebaseConfig, AUTH_APP_NAME);
    this.auth = getAuth(this.app);
  }

  /** Opens the Google sign-in popup and resolves with a fresh Firebase ID token. */
  async signInWithGoogle(): Promise<string> {
    const provider = new GoogleAuthProvider();
    provider.setCustomParameters({ prompt: "select_account" });
    const credential = await signInWithPopup(this.auth, provider);
    return credential.user.getIdToken();
  }
}
